import gql from 'graphql-tag';

export default gql`
  fragment optionFragment on OptionType {
    id
    optionType
    name
    description
  }
`;
